export default [
  {
    name: "Trend Report",
    path: "/trend-reports",
    component: () => import("@/modules/trendReports/pages/Report"),
    meta: {
      ability: [
        {
          resource: "trend-reports",
          actions: ["read"],
        },
      ],
    },
  },
]
